import { ViewResolver } from '@Components/ViewResolver';
import { OptionExtended } from '@Components/types/options';

import PresentationDesktopRequestHeader from './desktop/PresentationDesktopRequestHeader';
import PresentationMobileRequestHeader from './mobile/PresentationMobileRequestHeader';

interface PresentationHeaderProps {
  caption: string;
  showSelect?: boolean;
  labelSelectOption?: string;
  selectOptions?: OptionExtended[];
  children?: React.ReactNode;
  selectedValue?: string;
  requestType?: 'ESS' | 'MR';
  handleSelect?: (label: string, value: string | null) => void;
  onRequestSelectorOpen?: () => void;
}

const PresentationRequestHeader: React.FC<PresentationHeaderProps> = ({
  caption,
  children,
  selectOptions,
  handleSelect,
  selectedValue = '',
  onRequestSelectorOpen,
  showSelect = true,
  requestType = 'ESS',
  labelSelectOption = 'Request Type',
}) => {
  return (
    <ViewResolver
      desktop={
        <PresentationDesktopRequestHeader
          selectOptions={selectOptions}
          handleSelect={handleSelect}
          selectedValue={selectedValue}
          onRequestSelectorOpen={onRequestSelectorOpen}
          caption={caption}
          showSelect={showSelect}
          labelSelectOption={labelSelectOption}
        >
          {children}
        </PresentationDesktopRequestHeader>
      }
      mobile={
        <PresentationMobileRequestHeader
          selectOptions={selectOptions}
          handleSelect={handleSelect}
          selectedValue={selectedValue}
          onRequestSelectorOpen={onRequestSelectorOpen}
          requestType={requestType}
          showSelect={showSelect}
          labelSelectOption={labelSelectOption}
        >
          {children}
        </PresentationMobileRequestHeader>
      }
    />
  );
};

export default PresentationRequestHeader;
